import { useIsPaidPortal } from './useProductInventory';
import { useIsInAppAuth } from './useUserInfo';
export const useAddOnsPage = () => {
  const {
    isPaidPortal,
    loading: isInventoryLoading
  } = useIsPaidPortal();
  const isAppAuth = useIsInAppAuth();
  const showAddonsPage = isAppAuth && isPaidPortal && !isInventoryLoading;
  return {
    showAddonsPage
  };
};